import useFormikHelper from "hooks/useFormikHelper";
import { ContactPoint } from "models/Company"

type LinksListType = {
    urls: ContactPoint[] | undefined,
    soMe: ContactPoint[] | undefined,
    emails: ContactPoint[] | undefined
}

export default function LinksList({urls, soMe, emails}:LinksListType) {
    
    const { soMeExists } = useFormikHelper();

    if(urls === undefined && emails === undefined) {
        return (<></>)
    }
    
    const mainEmail = emails?.find(x => x.isMain) !== undefined ? emails?.find(x => x.isMain) :  emails?.[0];
    const mainUrl = urls?.find(x => x.isMain) !== undefined ? urls?.find(x => x.isMain) : urls?.[0];

    

    return (
        <tbody>
            {mainEmail && (<tr><th>E-post</th><td>{mainEmail.value}</td></tr>)}
            {mainUrl && (<tr><th>Hjemmeside</th><td>{mainUrl.value}</td></tr>)}
            {urls?.map((cp:ContactPoint, index:number) => {
                if(index !== urls.findIndex(x => x === mainUrl)) {
                    return (
                        <tr key={"cp_url_" + index}>
                            <th>{cp.label}</th>
                            <td>{cp.value}</td>
                        </tr>
                    )
                }
                return null;
            })}
            {soMe?.map((cp:ContactPoint, index:number) => {
                    return (
                        <tr key={"cp_some_" + index}>
                            <th>{cp.label}</th>
                            <td>{cp.value}</td>
                        </tr>
                    )
            })}
        </tbody>
    )
}